import React from 'react';
import { Link } from 'react-router-dom';
import { EXCHANGE_URL } from '../../constants';
import StepZilla from 'react-stepzilla';
import './step.css';

function UnusedComp() {
    return <div></div>
}

function Done() {
    return (
        <div className="panel panel-default" style={{ marginTop: '30px' }}>
            <div className="panel-heading">Step4. 繳費完成</div>
            <div className="panel-body">
                <h4>繳費完成</h4>
                <p>
                    可至遊戲酒吧官網進行<a style={{ color: '#00a0e9' }} href={EXCHANGE_URL} target="_blank">兌換點數</a>
                    或返回<Link style={{ color: '#00a0e9' }} to="/shop">VIP專屬儲值頁面</Link>
                </p>
            </div>
        </div>
    );
}

function WebAtmResult(props) {
    const steps = [
        { name: '選擇付款方式與金額', component: <UnusedComp /> },
        { name: '填寫個人資料', component: <UnusedComp /> },
        { name: '建立訂單', component: <UnusedComp /> },
        { name: '繳費', component: <Done /> },
    ];
    return (
        <div className="container">
            <div className="page-header text-center">
                <h1>VIP專屬儲值</h1>
            </div>
            <div className="row">
                <div className="col-sm-offset-1 col-sm-10 col-xs-12">
                    <div className='step-progress'>
                        <StepZilla
                            startAtStep={3}
                            prevBtnOnLastStep={true}
                            showNavigation={false}
                            stepsNavigation={false}
                            steps={steps} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WebAtmResult;


// WEBPACK FOOTER //
// ./src/containers/shop/webAtmResult.jsx